import { api } from '../api';
import { AxiosError } from 'axios';
import { CONFLICT } from 'http-status-codes';
import { range } from '@/utils/range';

export function validEmail(email: string) {
  return !!email.match(/^[^@]+@[^@]+\.[^@]+$/)
}

export function validPassword(password: string) {
  return password.length >= 8
}

export async function validNickname(nickname: string) {
  const axios = api.passErrors(CONFLICT)
  try {
    await axios.get('../api/v1/available_nickname', { params: { nickname } })
  } catch (e) {
    const error: AxiosError = e
    if (error.response!.status === CONFLICT) {
      return false
    }
  }
  return true
}

export function integerString(s: string) {
  const z = '０１２３４５６７８９　'.split('')
  const h = '0123456789 '.split('')
  const map = new Map(range(z.length).map((i) => [z[i], h[i]]))
  s = s.split('').map((c) => map.has(c) ? map.get(c) : c).join('').trim()
  return {
    valid: !!s.match(/^\d+$/),
    value: Number(s),
  }
}
